import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { ColliRoutes } from '../colli/colli-routes';
import { PackageRoutes } from '../package/package-routes';

const TransactionOverview = lazy(() => import('../transaction/transaction-overview'));
const TransactionDetail = lazy(() => import('../transaction/transaction-detail/transaction-detail.component'));
const TransactionTimerCreate = lazy(() => import('../transaction-timer/transaction-timer-create/transaction-timer-create.component'));
const TransactionTimerUpdate = lazy(() => import('../transaction-timer/transaction-timer-update/transaction-timer-update.component'));

const ColliRoute = ColliRoutes();
const PackageRoute = PackageRoutes();

export function TransactionRoutes() {
    return (
        <Route path='transactions'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <TransactionOverview />
                    </AsyncComponent>
                }
            />
            <Route
                index
                element={<Navigate to='/transactions' />}
            />
            <Route path=':transactionId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <TransactionDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='timers/create'
                    element={
                        <AsyncComponent>
                            <TransactionTimerCreate />
                        </AsyncComponent>
                    }
                />
                <Route path='timers'>
                    <Route
                        path=':timerId/update'
                        element={
                            <AsyncComponent>
                                <TransactionTimerUpdate />
                            </AsyncComponent>
                        }
                    />
                </Route>
                {PackageRoute}
                {ColliRoute}
            </Route>
        </Route>
    );
}
